import { AlertTriangle, Loader, X } from 'lucide-react';

// Custom Confirmation Modal Component
export const ConfirmationModal = ({ isOpen, disabled, loadingText, onClose, onConfirm, title, message, confirmText = "Delete", cancelText = "Cancel", isDestructive = false }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 overflow-y-auto">
            {/* Backdrop */}
            <div className="fixed inset-0 bg-black/30 transition-opacity" onClick={onClose}></div>

            {/* Modal */}
            <div className="flex min-h-full items-center justify-center p-4">
                <div className="relative bg-gray-800 rounded-lg shadow-xl max-w-md w-full border border-gray-700">
                    {/* Close Button */}
                    <button
                        onClick={onClose}
                        className="absolute top-4 right-4 text-gray-400 hover:text-gray-300 transition-colors"
                    >
                        <X size={20} />
                    </button>

                    {/* Content */}
                    <div className="p-6">
                        {/* Icon */}
                        <div className="flex items-center justify-center w-12 h-12 mx-auto mb-4 bg-red-500/20 rounded-full">
                            <AlertTriangle className="w-6 h-6 text-red-400" />
                        </div>

                        {/* Title */}
                        <h3 className="text-lg font-semibold text-white text-center mb-2">
                            {title}
                        </h3>

                        {/* Message */}
                        <p className="text-gray-300 text-center mb-6">
                            {message}
                        </p>

                        {/* Actions */}
                        <div className="flex gap-3">
                            {!disabled && <button
                                onClick={onClose}
                                className="flex-1 px-4 py-2 text-sm font-medium text-gray-300 bg-gray-700 border border-gray-600 rounded-lg hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500 transition-colors"
                            >
                                {cancelText}
                            </button>}
                            <button
                                disabled={disabled}
                                onClick={onConfirm}
                                className={`flex-1 flex disabled:cursor-not-allowed justify-center items-center px-4 py-2 text-sm font-medium rounded-lg focus:outline-none focus:ring-2 transition-colors ${isDestructive
                                    ? 'text-white bg-red-600 hover:bg-red-700 focus:ring-red-500'
                                    : 'text-white bg-blue-600 hover:bg-blue-700 focus:ring-blue-500'
                                    }`}
                            >
                                {disabled ? <div className='flex items-center gap-1.5'>
                                    <span>{loadingText}</span>{' '}
                                    <Loader size={16} className='animate-spin' />
                                </div> : confirmText}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
